exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._3Q3WTxWo5knORCnmeC6PJs_0{display:inline-block;background-size:cover;background-position:50%;background-color:#ccc;border-radius:50%}", "", {"version":3,"sources":["D:/alexlees.github.io/src/components/Avatar.vue"],"names":[],"mappings":"AACA,2BAAQ,qBAAqB,sBAAsB,wBAAwB,sBAAsB,iBAAiB,CACjH","file":"Avatar.vue","sourcesContent":["\n.avatar{display:inline-block;background-size:cover;background-position:50%;background-color:#ccc;border-radius:50%\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"avatar": "_3Q3WTxWo5knORCnmeC6PJs_0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7eb0138b","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Avatar.vue
// module id = 222
// module chunks = 0 1 2 3 4 5 6 13 14